import React from 'react';
import {selectedCompanyStore} from "../../store/SelectedCompany";
import LoaderWithCompanySelected from "../../components/LoaderWithCompanySelected";
import MyMaterialTable from "../../components/mtable/MyMaterialTable";
import {CustomerDto} from "../../model/customer/Customer";
import AddIcon from '@mui/icons-material/Add';
import {Button, IconButton} from "@mui/material";
import EditCustomerDialog from "./EditCustomerDialog";
import EditIcon from "@mui/icons-material/Edit";
import CountrySelector from "../../components/selector/CountrySelector";
import {customersStore} from "../../store/CustomersStore";
import {observer} from "mobx-react";
import {Translation} from "react-i18next";

interface IProps {
}

interface IState {
    loading: boolean,
    error: boolean,

    defaultSearchText?: string,
    showEditCustomerDialog: boolean,
    customerId?: string
}

@observer
export default class CustomersList extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = CustomersList.defaultState();
    }

    private static defaultState() {
        return {
            loading: true,
            error: false,
            showEditCustomerDialog: false,
        };
    }

    async componentDidMount() {
        if (selectedCompanyStore.isSelected) {
            this.refreshCustomers();
        }
    }

    private refreshCustomers = () => {
        this.setState({...CustomersList.defaultState()});
        customersStore.refresh()
                .then(() => {
                            this.setState({
                                loading: false
                            })
                        }
                )
                .catch(() => this.setState({
                    loading: false,
                    error: true
                }));
    }

    render() {
        const {loading, error, customerId, showEditCustomerDialog, defaultSearchText} = this.state;
        return <>
            <LoaderWithCompanySelected loading={loading} error={error}>
                <Translation>
                    {t =>
                            <MyMaterialTable
                                    title={t("customers_list.title", "Customers")}
                                    columns={[
                                        {title: t("customers_list.name", "Name"), field: 'name',},
                                        {title: t("customers_list.address", 'Address'), field: 'address'},
                                        {title: t("customers_list.city", 'City'), field: 'city'},
                                        {title: t("customers_list.post_code", 'Post code'), field: 'postalCode'},
                                        {title: t("customers_list.country", 'Country'), field: 'countryName'},
                                    ]}
                                    data={customersStore.customers.map(it => {
                                        return {...it, countryName: CountrySelector.findByCode(it.countryCode)?.name}
                                    })}
                                    options={{
                                        search: true,
                                        sorting: true,
                                        paging: true,
                                        pageSize: 10,
                                        draggable: false,
                                        actionsColumnIndex: 1000,
                                        searchText: defaultSearchText,
                                    }}
                                    actions={[
                                        {
                                            icon: () => <IconButton
                                                    color="primary"
                                                    onClick={() => {
                                                        this.setState({
                                                            customerId: undefined,
                                                            showEditCustomerDialog: true,
                                                        })
                                                    }}
                                                    size="large"><AddIcon/></IconButton>,
                                            tooltip: 'Add new client',
                                            isFreeAction: true,
                                            onClick: () => {
                                            }
                                        },
                                        row => ({
                                            icon: () => <Button variant="contained" color="primary" startIcon={<EditIcon/>}
                                                                onClick={() => {
                                                                    this.setState({
                                                                        customerId: row.id,
                                                                        showEditCustomerDialog: true,
                                                                    })
                                                                }}>Edit</Button>,
                                            onClick: () => {
                                            }
                                        }),
                                    ]}
                            />
                    }
                </Translation>
            </LoaderWithCompanySelected>
            {showEditCustomerDialog && <EditCustomerDialog customerId={customerId} open={showEditCustomerDialog}
                                                           onSave={this.handleSave}
                                                           onCancel={this.handleClose}
            />
            }
        </>;
    }

    private handleSave = async (changeCustomer: CustomerDto) => {
        this.setState({
            defaultSearchText: changeCustomer.name,
            showEditCustomerDialog: false
        })
        await this.refreshCustomers();
    }

    private handleClose = () => {
        this.setState({
            showEditCustomerDialog: false
        })
    }
}